













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TextInput from "@/components/TextInput.vue";
import DropDownInput from "@/components/DropDownInput.vue";
import { pinboardService } from "@/services/pinboard.service";
import { PinBoard } from '@/models/pinboard.model';
import store from "@/store/store";

require("@/assets/css/modal.scss");

@Component(
    {
        components : {
            TextInput,
            DropDownInput,
        }
    }
)
export default class PinboardModal extends Vue{
    @Prop() private id!: number;

    showContent:boolean = false;
    pinboard:PinBoard = {name:"",description: "", showStatistics : false, usersPerPage:12};

    errors:string[]=[];

    close(){
        this.showContent = false;
        this.$emit("modalEmit", 'close');
    }

    async save(){
        store.dispatch("app/resetErrors");
        this.pinboard.companyId = store.getters["app/companyId"];
        pinboardService.create(this.pinboard).then((response) =>{ 
            this.pinboard.id = response.data;
            this.$notify({
                group: 'message',
                title: 'Succe!',
                text: 'Tavla skapad',
                duration: 5000,
                type: 'success',
            });
            this.$emit("modalEmit", 'saved', this.pinboard.id);
            this.$store.dispatch("app/getCompanyPinBoards");
        });
    }

    async update(){
        store.dispatch("app/resetErrors");
        pinboardService.update(this.pinboard).then((response) => 
        {
            this.$notify({
                group: 'message',
                title: 'Succe!',
                text: 'Tavla uppdaterad',
                duration: 5000,
                type: 'success',
            });
            this.$emit("modalEmit", 'saved');
            this.$store.dispatch("app/getCompanyInfoFromKey", store.getters["auth/companyId"]);
        });
    }

    @Watch('id')
    async idChanged(){
        this.errors = [];
        if(this.id != 0)
            this.pinboard = await pinboardService.get(this.id);
        else{
            this.pinboard = {name:"",description: "", showStatistics : true, usersPerPage:12};
        }
    }
}
